import { NodeEntity } from './node.types';

export type ManifestType = 'pickup_run' | 'delivery_run' | 'transfer_run' | 'hub_inbound' | 'hub_outbound' | 'return_pickup_run' | 'return_delivery_run';
export type ManifestStatus = 'draft' | 'assigned' | 'accepted' | 'in_progress' | 'completed' | 'partially_completed' | 'disputed';

export interface Manifest {
  id: string;
  manifest_number: string;
  manifest_type: ManifestType;
  carrier_id: string;
  driver_id: string;
  driver?: { id: string; name: string; phone: string; user?: { id: string; name: string } };
  node_id: string;
  node?: NodeEntity;
  date: string;
  status: ManifestStatus;
  total_trips: number;
  completed_trips: number;
  failed_trips: number;
  total_cod_to_collect: number;
  total_cod_collected: number;
  started_at?: string;
  completed_at?: string;
  received_by?: string;
  received_at?: string;
  driver_acknowledged?: boolean;
  driver_acknowledged_name?: string;
  dispatched_by?: string;
  dispatched_at?: string;
  created_at: string;
}

export const MANIFEST_TYPE_LABELS: Record<ManifestType, string> = {
  pickup_run: 'قائمة الالتقاط',
  delivery_run: 'قائمة التوصيل',
  transfer_run: 'قائمة النقل',
  hub_inbound: 'قائمة الوارد',
  hub_outbound: 'قائمة الصادر',
  return_pickup_run: 'قائمة استلام المرتجعات',
  return_delivery_run: 'قائمة الإرجاع للمرسل',
};

export const MANIFEST_STATUS_LABELS: Record<ManifestStatus, string> = {
  draft: 'مسودة',
  assigned: 'معين',
  accepted: 'تم القبول',
  in_progress: 'قيد التنفيذ',
  completed: 'مكتمل',
  partially_completed: 'مكتمل جزئياً',
  disputed: 'متنازع عليه',
};
